import React, { memo, useCallback, useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Alert, Button, Modal, Typography } from 'antd';

import eduzzAccountsService from 'v2/services/eduzzAccount';
import { fidcService } from 'v2/services/fidc';

const ModalFidc = memo(() => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen(prev => !prev), []);

  const validateUser = useCallback(async (): Promise<void> => {
    if (!user) return;

    try {
      const result = await fidcService.validateCustomerReject(user.id);
      if (result?.data && !Array.isArray(result?.data)) toggle();
    } catch {
      // silent: modal is optional communication
    }
  }, [toggle, user]);

  useEffect(() => {
    validateUser();
  }, [validateUser]);

  return (
    <Modal
      open={open}
      onCancel={toggle}
      title='Comunicado importante para você!'
      footer={
        <div className='flex justify-end'>
          <Button type='primary' onClick={toggle}>
            Entendi
          </Button>
        </div>
      }
    >
      <div className='flex flex-col gap-4'>
        <Alert
          type='warning'
          showIcon
          message='Irregularidades no cadastro'
          description={
            <>
              Notamos que há irregularidades em seu cadastro e para que você continue vendendo com a Eduzz é necessário
              realizar a{' '}
              <Typography.Text strong>regularização do seu CPF e/ou CNPJ junto a Receita Federal.</Typography.Text>
            </>
          }
        />
        <Typography.Paragraph className='mb-0'>
          Para que possamos continuar nossa parceria juntos, pedimos que{' '}
          <Typography.Text strong>até dezembro</Typography.Text> deste ano você regularize seus dados cadastrais com a
          Receita Federal, para evitar qualquer tipo de problema. Combinado?
        </Typography.Paragraph>
        <Typography.Paragraph className='mb-0'>
          Conte sempre com a gente.
          <br />
          Eduzz.
        </Typography.Paragraph>
      </div>
    </Modal>
  );
});

export default ModalFidc;
